<template>
  <div>
    <navbar/>
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <div class="container-fluid footer centered">
  		<div class="container">
  			<div class="row">
  				<div class="col-12">
  					© Курсы экскурсоводов, 2022. ООО "ТТ СПБ". ОГРН: 1147847388226
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
export default {
  name: 'app',
  components: { Navbar },
  beforeMount () {
    const token = localStorage.getItem('token')
    if (token) {
      this.$http.post('auth/check', {}, { headers: { Authorization: token } })
        .then(
          success => {
            this.$store.dispatch('login', success.data)
            this.$store.dispatch('userCheck')
          },
          error => {
            if (error.status === 401) {
              localStorage.removeItem('token')
              this.$store.dispatch('userCheck')
            }
          }
        )
    } else {
      this.$store.dispatch('userCheck')
    }
  }
}
</script>

<style>
  button {
    cursor: pointer;
  }
  button[disabled = 'disabled'] {
    cursor: not-allowed;
  }
  .modal-dialog {
    margin-top: 25vh!important;
  }
  .modal {
    overflow-y: auto;
  }

  .modal-open {
    overflow: auto!important;
  }

  .is-invalid .form-control {
    border-color: #dc3545;
  }

  .is-invalid .col-form-label, .is-invalid .custom-control-description {
    color: #dc3545;
  }

  .vdp-datepicker__calendar {
    max-width: 260px;
  }

  h1, h2 {
    color: #3c1316;
  }
  .wait {
    cursor: wait!important;
  }
  .nav-tabs>li>a, .nav-tabs>li>a:hover, .nav-tabs>li>a:visited {
    color: black;
  }
  .centered {
    text-align: center;
  }
  .main-area {
    padding-top: 125px;
    padding-bottom: 50px;
    min-height: 100vh;
  }
  .content {
    min-height: 60vh;
    padding: 30px 0;
  }
  .my-10 {
		margin-top: 50px;
		margin-bottom: 50px;
	}
  .footer {
		padding: 50px 0;
		background-color: #483233;
		background-color: #2e2e2e;
		color: white;
	}
  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .2s;
  }

  .fade-enter-active {
    transition-delay: .2s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    display: none;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5a12819a